import PropTypes from 'prop-types';
import React from 'react';
import cx from '../../utils/cx.js';

const ReactPropTypes = PropTypes;

class ImageSvg extends React.Component {
	static propTypes = {
	  svg: ReactPropTypes.string,
	  full: ReactPropTypes.bool,
	  iconClass: ReactPropTypes.string,
	};

	static defaultProps = {
	  svg: '',
	  full: false,
	  iconClass: null,
	};

	render() {
	  return (
  <svg
    className={cx([
					'icon',
					['icon--full', this.props.full],
					[this.props.iconClass, this.props.iconClass],
				])}
  >
    <use xlinkHref={`#${this.props.svg}`} />
  </svg>
	  );
	}
}

module.exports = ImageSvg;
